import { Gift, Heart, Flower2, Snowflake, Zap, Percent, GraduationCap, Star, PartyPopper, Egg, Ghost, Moon, Sparkles, Cake, Drama, Wine, Ribbon, Flag } from "lucide-react";

const nthSunday = (y, m, n) => { const d = new Date(y, m, 1); d.setDate(1 + ((7 - d.getDay()) % 7) + 7 * (n - 1)); return d; };
const blackFriday = (y) => { const d = new Date(y, 10, 1); d.setDate(1 + ((4 - d.getDay() + 7) % 7) + 21 + 1); return d; };
const around = (d, before, after) => [new Date(d.getTime() - before * 864e5), new Date(d.getTime() + after * 864e5)];

export const SEASONS = {
  noel: {
    label: "Noël", icon: Gift, deco: [Snowflake, Star], dark: true, tone: "gold",
    bg: "bg-[radial-gradient(120%_120%_at_80%_20%,#8e1b2b_0%,#4a0a14_55%,#22040a_100%)] text-white",
    accent: "text-[#f5c46b]", eyebrow: "Idées cadeaux de Noël", withName: true, title: "Offrez un", accent2: "reconditionné belge.",
    badge: ["Idée cadeau", "garantie 36 mois"],
    vars: { blue: "#c8102e", link: "#a50e26", bg: "#fbf4ef" }, bar: "bg-[#4a0a14] text-white", code: "NOEL26", ribbon: "Idée cadeau",
    gift: ["Idées cadeaux", "sous le sapin."],
  },
  "saint-valentin": {
    label: "Saint-Valentin", icon: Heart, deco: [Heart], dark: false, tone: "rose",
    bg: "bg-[radial-gradient(120%_120%_at_80%_20%,#ffd1dc_0%,#fff0f4_50%,#ffffff_100%)]",
    accent: "text-[#e11d48]", eyebrow: "Saint-Valentin", title: "Pour votre moitié,", accent2: "un cadeau qui dure.",
    badge: ["Coup de cœur", "Saint-Valentin"],
    vars: { blue: "#e11d48", link: "#be123c", bg: "#fff4f6" }, bar: "bg-[#e11d48] text-white", code: "LOVE26", ribbon: "Coup de cœur",
    gift: ["Un cadeau", "pour votre moitié."],
  },
  "fete-des-meres": {
    label: "Fête des mères", icon: Flower2, deco: [Flower2, Heart], dark: false, tone: "lilac",
    bg: "bg-[radial-gradient(120%_120%_at_80%_20%,#ead9ff_0%,#f7f0ff_50%,#ffffff_100%)]",
    accent: "text-[#8b3fd9]", eyebrow: "Fête des mères", title: "Pour maman,", accent2: "le meilleur du reconditionné.",
    badge: ["Fête des mères", "idée cadeau"],
    vars: { blue: "#8b3fd9", link: "#7a2fc4", bg: "#faf5ff" }, bar: "bg-[#8b3fd9] text-white", code: "MAMAN26", ribbon: "Pour maman",
    gift: ["Cadeaux", "pour maman."],
  },
  "fete-des-peres": {
    label: "Fête des pères", icon: Star, deco: [Star], dark: true, tone: "gold",
    bg: "bg-[radial-gradient(120%_120%_at_80%_20%,#1e3a6b_0%,#0f1f3d_55%,#070f1f_100%)] text-white",
    accent: "text-[#7cc4ff]", eyebrow: "Fête des pères", title: "Pour papa,", accent2: "un vrai bon plan.",
    badge: ["Fête des pères", "idée cadeau"],
    vars: { blue: "#1e4fa3", link: "#1a3f80", bg: "#f2f5fb" }, bar: "bg-[#0f1f3d] text-white", code: "PAPA26", ribbon: "Pour papa",
    gift: ["Cadeaux", "pour papa."],
  },
  rentree: {
    label: "Rentrée", icon: GraduationCap, deco: [GraduationCap, Star], dark: false, tone: "blue",
    bg: "bg-[radial-gradient(120%_120%_at_80%_20%,#fff3b0_0%,#fffbe6_50%,#ffffff_100%)]",
    accent: "text-[var(--blue)]", eyebrow: "Spécial rentrée", title: "Prêt pour la rentrée", accent2: "à petit prix.",
    badge: ["Rentrée", "petits prix"],
    vars: { blue: "#0071e3", link: "#0066cc", bg: "#fffcef" }, bar: "bg-[#ffd60a] text-black", code: "RENTREE26", ribbon: "Spécial rentrée",
    gift: ["Équipé pour la rentrée,", "à petit prix."],
  },
  "black-friday": {
    label: "Black Friday", icon: Zap, deco: [Zap], dark: true, tone: "neon",
    bg: "bg-[radial-gradient(120%_120%_at_80%_20%,#26262b_0%,#0b0b0d_60%,#000_100%)] text-white",
    accent: "text-[#e8ff3a]", eyebrow: "Black Friday", title: "Black Friday :", accent2: "les prix tombent.",
    badge: ["Black Friday", "offres limitées"],
    vars: { blue: "#2b59ff", link: "#2b59ff", bg: "#efefef" }, bar: "bg-black text-[#e8ff3a]", code: "BLACK26", ribbon: "Black Friday",
    gift: ["Les offres", "Black Friday."],
  },
  "nouvel-an": {
    label: "Nouvel An", icon: PartyPopper, deco: [Sparkles, Star], dark: true, tone: "gold",
    bg: "bg-[radial-gradient(120%_120%_at_80%_20%,#2b2410_0%,#121008_55%,#000_100%)] text-white",
    accent: "text-[#f5c46b]", eyebrow: "Bonne année", title: "Nouvelle année,", accent2: "nouvel iPhone.",
    badge: ["Bonne année", "garantie 36 mois"],
    vars: { blue: "#b8860b", link: "#9a7009", bg: "#faf7ef" }, bar: "bg-black text-[#f5c46b]", code: "", ribbon: "Bonne année",
    gift: ["Bien commencer", "l'année."],
  },
  anniversaire: {
    label: "Anniversaire Smarti", icon: Cake, deco: [PartyPopper, Star], dark: false, tone: "blue",
    bg: "bg-[radial-gradient(120%_120%_at_80%_20%,#cfe3ff_0%,#eef5ff_50%,#ffffff_100%)]",
    accent: "text-[#0073FF]", eyebrow: "Anniversaire Smarti", title: "C'est notre anniversaire,", accent2: "on fête ça avec vous.",
    badge: ["Anniversaire", "Smarti"],
    vars: { blue: "#0073FF", link: "#0060d6", bg: "#f3f8ff" }, bar: "bg-[#0073FF] text-white", code: "", ribbon: "Anniversaire",
    gift: ["L'anniversaire", "Smarti."],
  },
  carnaval: {
    label: "Carnaval", icon: Drama, deco: [Sparkles, Star], dark: false, tone: "lilac",
    bg: "bg-[radial-gradient(120%_120%_at_80%_20%,#fff3a3_0%,#ffe1f1_45%,#e9ddff_100%)]",
    accent: "text-[#c026d3]", eyebrow: "Carnaval", title: "Le carnaval,", accent2: "en couleurs.",
    badge: ["Carnaval", "Smarti"],
    vars: { blue: "#c026d3", link: "#a21caf", bg: "#fff7fd" }, bar: "bg-[#c026d3] text-white", code: "", ribbon: "Carnaval",
    gift: ["Le carnaval", "en couleurs."],
  },
  paques: {
    label: "Pâques", icon: Egg, deco: [Egg, Flower2], dark: false, tone: "green",
    bg: "bg-[radial-gradient(120%_120%_at_80%_20%,#d9f7d6_0%,#fdf8e4_50%,#ffffff_100%)]",
    accent: "text-[#2f9e44]", eyebrow: "Pâques", title: "À Pâques,", accent2: "cachez un iPhone.",
    badge: ["Pâques", "idée cadeau"],
    vars: { blue: "#2f9e44", link: "#237a34", bg: "#f7fcf3" }, bar: "bg-[#2f9e44] text-white", code: "", ribbon: "Pâques",
    gift: ["Cadeaux", "de Pâques."],
  },
  halloween: {
    label: "Halloween", icon: Ghost, deco: [Moon, Ghost], dark: true, tone: "orange",
    bg: "bg-[radial-gradient(120%_120%_at_80%_20%,#3b1d5c_0%,#1a0b2e_55%,#07030f_100%)] text-white",
    accent: "text-[#ff8a1f]", eyebrow: "Halloween", title: "Des prix à faire peur,", accent2: "sans mauvaise surprise.",
    badge: ["Halloween", "offres"],
    vars: { blue: "#ff6a1a", link: "#e0560f", bg: "#f6f2fa" }, bar: "bg-[#1a0b2e] text-[#ff8a1f]", code: "", ribbon: "Halloween",
    gift: ["Les offres", "d'Halloween."],
  },
  "saint-nicolas": {
    label: "Saint-Nicolas", icon: Gift, deco: [Star, Snowflake], dark: true, tone: "gold",
    bg: "bg-[radial-gradient(120%_120%_at_80%_20%,#b91c1c_0%,#7f1010_55%,#3d0606_100%)] text-white",
    accent: "text-[#f5c46b]", eyebrow: "Saint-Nicolas", title: "Saint Nicolas passe", accent2: "chez Smarti.",
    badge: ["Saint-Nicolas", "idée cadeau"],
    vars: { blue: "#b91c1c", link: "#991b1b", bg: "#fbf4ef" }, bar: "bg-[#7f1010] text-[#f5c46b]", code: "", ribbon: "Saint-Nicolas",
    gift: ["Pour les sages", "de la maison."],
  },
  "saint-sylvestre": {
    label: "Saint-Sylvestre", icon: Wine, deco: [Sparkles, Star], dark: true, tone: "gold",
    bg: "bg-[radial-gradient(120%_120%_at_80%_20%,#1e2a5a_0%,#0c1230_55%,#03050f_100%)] text-white",
    accent: "text-[#f5c46b]", eyebrow: "Saint-Sylvestre", title: "Finissez l'année", accent2: "en beauté.",
    badge: ["Réveillon", "garantie 36 mois"],
    vars: { blue: "#b8860b", link: "#9a7009", bg: "#f6f6fb" }, bar: "bg-[#0c1230] text-[#f5c46b]", code: "", ribbon: "Réveillon",
    gift: ["Pour le", "réveillon."],
  },
  soldes: {
    label: "Soldes", icon: Percent, deco: [Percent], dark: false, tone: "red",
    bg: "bg-[radial-gradient(120%_120%_at_80%_20%,#ffd6d1_0%,#fff1ef_50%,#ffffff_100%)]",
    accent: "text-[#e5321b]", eyebrow: "Soldes", title: "C'est les soldes", accent2: "chez Smarti.",
    badge: ["Soldes", "stocks limités"],
    vars: { blue: "#e5321b", link: "#c42a15", bg: "#fff5f3" }, bar: "bg-[#e5321b] text-white", code: "SOLDES26", ribbon: "Soldes",
    gift: ["Les soldes", "Smarti."],
  },
  "octobre-rose": {
    label: "Octobre rose", icon: Ribbon, deco: [Ribbon, Heart], dark: false, tone: "rose",
    bg: "bg-[radial-gradient(120%_120%_at_80%_20%,#ffc9dc_0%,#fff0f5_50%,#ffffff_100%)]",
    accent: "text-[#d63a7a]", eyebrow: "Octobre rose", title: "En octobre,", accent2: "on voit la vie en rose.",
    badge: ["Octobre rose", "solidaire"],
    vars: { blue: "#d63a7a", link: "#b82e66", bg: "#fff5f9" }, bar: "bg-[#d63a7a] text-white", code: "", ribbon: "Octobre rose",
    gift: ["La sélection", "Octobre rose."], colors: ["rose", "pink"],
  },
  "fete-nationale": {
    label: "Fête nationale", icon: Flag, deco: [Sparkles, Star], dark: true, tone: "gold",
    bg: "bg-[linear-gradient(115deg,#111111_0%,#111111_30%,#3a2d00_55%,#5c0a10_100%)] text-white",
    accent: "text-[#fdda24]", eyebrow: "21 juillet · Fête nationale", title: "Vive la Belgique,", accent2: "vive le reconditionné belge.",
    badge: ["Fête nationale", "made in Belgium"],
    vars: { blue: "#ef3340", link: "#c8202c", bg: "#fffbea" }, bar: "bg-[#111] text-[#fdda24] shadow-[inset_0_-3px_0_#ef3340]", code: "", ribbon: "21 juillet",
    gift: ["Les offres", "de la Fête nationale."],
  },
};

const easter = (y) => {
  const a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4, g = Math.floor((8 * b + 13) / 25);
  const h = (19 * a + b - d - g + 15) % 30, i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451);
  const n = h + l - 7 * m + 114;
  return new Date(y, Math.floor(n / 31) - 1, (n % 31) + 1);
};
const before = (d) => [new Date(d.getTime() - 14 * 864e5), new Date(d.getTime() + 864e5 - 1)];

export function seasonRanges(y) {
  const ea = easter(y);
  return [
    ["nouvel-an", new Date(y, 0, 1), new Date(y, 0, 6, 23)],
    ["soldes", new Date(y, 0, 7), new Date(y, 0, 31, 23)],
    ["saint-valentin", ...before(new Date(y, 1, 14))],
    ["anniversaire", new Date(y, 1, 1), new Date(y, 1, 14, 23)],
    ["carnaval", ...before(new Date(ea.getTime() - 47 * 864e5))],
    ["paques", new Date(ea.getTime() - 14 * 864e5), new Date(ea.getTime() + 2 * 864e5 - 1)],
    ["fete-des-meres", ...before(nthSunday(y, 4, 2))],
    ["fete-des-meres", ...before(nthSunday(y, 5, 2))],
    ["fete-des-peres", ...before(nthSunday(y, 5, 2))],
    ["fete-des-peres", ...before(nthSunday(y, 9, 1))],
    ["fete-nationale", new Date(y, 6, 14), new Date(y, 6, 21, 23)],
    ["soldes", new Date(y, 6, 1), new Date(y, 6, 31, 23)],
    ["rentree", new Date(y, 7, 16), new Date(y, 8, 15, 23)],
    ["octobre-rose", new Date(y, 9, 1), new Date(y, 9, 7, 23)],
    ["halloween", ...before(new Date(y, 9, 31))],
    ["black-friday", ...around(blackFriday(y), 7, 3)],
    ["saint-nicolas", new Date(y, 10, 15), new Date(y, 11, 6, 23)],
    ["noel", new Date(y, 11, 7), new Date(y, 11, 25, 23)],
    ["saint-sylvestre", new Date(y, 11, 26), new Date(y, 11, 31, 23)],
  ];
}

export function seasonFor(date = new Date()) {
  const hit = seasonRanges(date.getFullYear()).find(([, a, b]) => date >= a && date <= b);
  return hit ? hit[0] : null;
}

export function daysLeft(key, date = new Date()) {
  const y = date.getFullYear();
  const r = [...seasonRanges(y), ...seasonRanges(y + 1)].filter(([k, a, b]) => k === key && a <= date && b >= date).sort((x, z) => x[2] - z[2])[0];
  return r ? Math.max(1, Math.ceil((r[2] - date) / 864e5)) : null;
}
